import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=058f8f58"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports